module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAABI0lEQVRYhe3Wzw2CMBTH8a/GAZyAeOAuI7iCE6hHJuKIbOAIbqDeORgmcATzkppgpfKvr8aE36W0kPST10eAKf+WWQhvmUYbYAesgAdQxFl1anpWHVSm0R7IG24d46w6BAV9wbyytSs1/yEGc4xvUQF1xEiW6qAeGMldFdQTIynUQAMwhzirzvail7dsIObYdGM0yCdmNMg3ZhRIAzMYpIUZBNLE9AZpY3qBQmA6g0JhOoFCYlpBoTFfQb/A4PHj6gUjWdgLZRolQCIblGlEhyp5w+CokIByOTKz0cePuBbGBVqbsQ3lHeMCJbVrF0oFQ1MPARtrLihqPYUWBvu1Nw19cTyrVpV67Aol1lz+ea/AzYzqsUF30yvXOKuCAKZM8RrgCeEGlHDCXXxBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_btn_edit_press@2x.png
// module id = 726
// module chunks = 0